export const isLocalhost = (url = window.location.href) => {
  const { hostname } = new URL(url);
  return hostname === "localhost" || hostname === "127.0.0.1";
};
